<template>
  <div class="overflow-hidden md:flex md:h-full">
    <SideBar class="w-48 md:flex-none hidden md:block"></SideBar>
    <main class="md:ml-4 p-0 md:flex-1">
      <div class="pt-2 sm:p-0 sm:m-0">
        <div class="pt-3 w-full md:w-100">
          <div class="md:flex md:flex-row">
            <div class="flex flex-row md:flex-col flex-shrink-0 overflow-hidden account-menu">
              <button class="nav-link" :class="`${ tab == 'profile'?'active':'' }`" @click="tab = 'profile'">Profile</button>
              <button class="nav-link" :class="`${ tab == 'wallet'?'active':'' }`" @click="tab = 'wallet'">Wallet</button>
              <button class="nav-link" :class="`${ tab == 'token'?'active':'' }`" @click="tab = 'token'">Tokens</button>
            </div>
            <div class="vr"></div>
            <div class="px-10 md:flex-grow">
              <myProfile v-if="tab == 'profile'" />
              <wallet v-else-if="tab == 'wallet'" />
              <tokens v-else />
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { ref, defineComponent } from "vue";
import SideBar from "@/layouts/home/SideBar.vue";
import myProfile from "@/modules/account/components/accountProfileComponent.vue";
import wallet from "@/modules/account/components/accountWalletComponent.vue";
import tokens from "@/modules/account/components/accountTokensComponent.vue";

export default defineComponent({
  name: "viewAccount",
  components: {
    SideBar,
    myProfile,
    wallet,
    tokens
  },
  setup(){
    const tab = ref('profile');
    return {
      tab,
    }
  }
});
</script>

<style lang="scss">
@import "@/assets/scss/global.scss";

.account-menu{
  @apply md:pr-5;
  .nav-link{
    @apply border-b-4 border-l-0 md:border-l-4 md:border-b-0 border-black-primary w-36 text-gray-text text-center md:text-left md:pl-3 py-2 text-sm;
  }

  .nav-link.active{
    @apply border-red-primary bg-black-header text-white;
  }
}

.border-color-theme {
  @apply border-black-border;
}

#v-pills-tab {
  margin-top: 5px;

  .nav-link {
    color: gray;
  }
  .active {
    // background: $color-side-nav;
    // border-bottom: 4px solid $color-text-red-primary;
    border-radius: 0;
    color: white;
  }
}

.vr {
  width: 2px !important;
  background: transparent;
  border-left: 1px solid #585858;
}

.tab-content{
  width: 100%;
}

@media only screen and (min-width: 768px) {
  #v-pills-tab {
    margin-top: 0;

    .nav-link {
      color: gray;
    }

    .active {
      // border-left: 4px solid $color-text-red-primary;
      border-bottom: 0;
      color: white;
    }
  }

  .tab-content{
    width: 75%;
  }
}
input {
  border: 0px solid black !important;
}
.form-control:focus {
  // background: $color-card;
}
</style>